import { dataHospitalSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconHospitalSolid = /*#__PURE__*/createIcon(dataHospitalSolid)
export default IconHospitalSolid
